import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { validateAllFormFields } from '../../shared/utilities';
import { AuthenticationService, IResetUserPasswordViewModel } from 'src/app/services';
import { Response } from 'src/app/models/generated-view-models';
import { ResponseTypeEnum } from 'src/app/models/enums';

interface IResetPasswordParams {
    email: string;
    token: string;
}

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
    public resetPasswordForm: FormGroup;
    public email: string = "example@gmail.com";
    public token: string = '';

    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute, 
        private authenticationService: AuthenticationService,
        private formBuilder: FormBuilder) { }

    ngOnInit() {
        this.activeRoute.queryParams.subscribe((params: IResetPasswordParams) => {
            this.buildForm(params.email);
            this.token = params.token;
        }, (err) => {
            this.buildForm();
        })
    }

    public buildForm = (email?: string): void => {
        this.resetPasswordForm = this.formBuilder.group({
            'email': [{value: email || '', disabled: true}, [Validators.required]],
            'password': [],
            'confirmPassword': []
        });
    }

    public submit = (): void => {
        if (!this.resetPasswordForm.valid) {
            validateAllFormFields(this.resetPasswordForm);
            return;
        } else {
            let resetPasswordRequest: IResetUserPasswordViewModel = {
                UserName: this.resetPasswordForm.get('email').value,
                NewPassword: this.resetPasswordForm.get('password').value,
                Token: this.token
            };
            this.authenticationService.ResetPassword(resetPasswordRequest).subscribe((res: boolean) => {
                if(res) {
                    this.router.navigate(['login']);
                    return true;
                } else {
                    return false;
                }
            }, (err) => {    
                return false;
            });  
            this.router.navigate(['/']);
        }
    }
}
